module.exports = __webpack_public_path__ + "d2421242c1b52f4a66a3dc8beae1773f.svg";